import React, { useEffect, useRef, useState } from 'react';

// Encaixa o mapa (fundo, ícones, bandeiras e trilha) na tela.
// Deitado: cobre a área toda. Em pé: preenche a altura e deixa arrastar para os lados,
// assim os ícones continuam grandes em vez de virar miniatura.
export const GbFit = ({ w = 1000, h = 545, children, testid, foco = 0.5 }) => {
  const box = useRef(null);
  const trilho = useRef(null);
  const [s, setS] = useState(1);
  const [rola, setRola] = useState(false);

  useEffect(() => {
    const el = box.current;
    if (!el) return undefined;
    const medir = () => {
      const r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      const estreito = r.width / r.height < (w / h) * 0.85;
      const esc = estreito ? r.height / h : Math.max(r.width / w, r.height / h);
      setS(esc);
      setRola(estreito);
      if (estreito && trilho.current) {
        trilho.current.scrollLeft = Math.max(0, w * esc * foco - r.width / 2);
      }
    };
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, [w, h, foco]);

  const escalado = (
    <div className="absolute left-0 top-0 origin-top-left"
      style={{ width: w, height: h, transform: `scale(${s})` }}>
      {children}
    </div>
  );

  if (!rola) {
    return (
      <div ref={box} data-testid={testid}
        className="absolute inset-0 flex items-center justify-center overflow-hidden">
        <div className="relative flex-none" style={{ width: w, height: h, transform: `scale(${s})` }}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div ref={box} data-testid={testid} className="absolute inset-0 overflow-hidden">
      <div ref={trilho} className="h-full w-full overflow-x-auto overflow-y-hidden"
        style={{ WebkitOverflowScrolling: 'touch', overscrollBehaviorX: 'contain' }}>
        <div className="relative" style={{ width: w * s, height: h * s }}>{escalado}</div>
      </div>
      <span className="pointer-events-none absolute right-2 top-2 z-30 rounded-full bg-black/60 px-2.5 py-1 text-[10px] font-bold text-purple-100"
        data-testid="gb-fit-hint">
        arraste para o lado →
      </span>
    </div>
  );
};
